module.exports = __webpack_public_path__ + "static/assets/visa.11fe086.png";